// The following memoryTypes are built-ins created in the Before trigger
// and thus always available.
export const BuildInMemoryTypes: Record<string, string> = {
  sentiment: 'Classification',
  contactReason: 'Classification',
  contactReasons: 'Classifications',
  console: 'string',
  conversation: 'Ticket',
  dateTime: 'DateTime',
  name: 'string',
  email: 'string',
  channel: 'Channel',
  agentAssist: 'AgentAssist',
};
